import React, { Component } from 'react'
import { Link } from 'react-router'
import { restUrl } from 'config'
import { connect } from 'react-redux'
import request from 'superagent'
import BackButton from 'components/backButton'
import { Modal } from 'react-bootstrap'
import { routeActions } from 'react-router-redux'
import moment from 'moment'


class ForumComponent extends Component {

  constructor(props) {
    super(props)
    this.getThreads = this.getThreads.bind(this)
    this.forum = this.props.forums.filter(forum => forum.title.split(' ').join('') === this.props.params.forumTitle)[0]
    this.state = {
      showModal: false,
      threads: []
    }
  }

  getThreads() {
    request
      .get(restUrl+'forum/'+this.forum._id)
      .end((err, res) => {
        if (!err) {
          this.setState({
            threads: res.body.threads
          })
        } else {
          this.setState({
            error: err.message
          })
        }
      })
  }

  open() {
    this.setState({
      showModal: true
    })
  }

  close() {
    this.setState({
      showModal: false
    })
  }

  onSubmit(e) {
    e.preventDefault()
    const title = this.refs.title.value
    const threadtext = this.refs.threadtext.value
    if (!!title && !!threadtext) {
      request
        .post(restUrl + 'forum/thread')
        .send({
          forum: this.forum._id,
          title,
          text: threadtext,
          author: {
            _id: this.props.auth.user.id,
            name: this.props.auth.user.forumName
          }
        })
        .end((err, res) => {
          if (!err) {
            const { threads } = this.state
            threads.push(res.body)
            this.setState({
              threads,
              showModal: false
            })
          }
        })
    }
  }

  componentDidMount() {
    if(!this.forum) {
      this.props.dispatch(routeActions.push('/404'))
    }
    else {
      this.getThreads()
    }
  }

  render() {

    if (!!this.state.err) {
      return <div>{ this.state.err }</div>
    }
    else if(!this.forum) {
      return (<div> loading... </div>)
    }

    return (
      <div className='container-fluid forum'>
        <BackButton />
        <div className='panel'>
          <header className='panel-heading'>
            <span>{this.forum.title}</span>
            <span className='pull-right'>{ this.forum.description }</span>
          </header>
          <div className='panel-body'>
            <ul className='list-group'>
              { this.state.threads.map(thread => {
                return (
                  <Link
                    key={thread._id}
                    className='list-group-item clearfix'
                    to={{
                        pathname:`/forum/${encodeURIComponent(this.forum.title.split(' ').join(''))}/${encodeURIComponent(thread.title.split(' ').join('').split('?')[0])}/`,
                        state:{
                          threadId: thread._id
                        }
                      }}>
                      <h4 className='list-group-item-heading pull-left'>{ thread.title }</h4>
                      <span className='pull-right'>{ 'By ' + thread.author.name + ' ' + moment(thread.createdAt).fromNow() }</span>
                  </Link>
                  )
                }) }

            </ul>
            <button type='button' className='btn btn-primary' onClick={this.open.bind(this)}>Create new thread</button>
          </div>
        </div>
        <Modal show={this.state.showModal} onHide={this.close.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>Create a new thread</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form className='form-horizontal'>
              <div className='form-group'>
                <label className='col-xs-2 control-label'>Title</label>
                <div className='col-xs-10'>
                  <input className='form-control' ref='title' type='text' />
                </div>
              </div>
              <div className='form-group'>
                <label className='col-xs-2 control-label'>Text</label>
                <div className='col-xs-10'>
                  <input className='form-control' ref='threadtext' type='text' />
                </div>
              </div>
              <div className='form-group'>
                <div className='col-xs-10 col-xs-offset-2'>
                  <button type='submit' className='btn btn-success' onClick={this.onSubmit.bind(this)}>Post to forum</button>
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>

      </div>
    )
  }
}

export default connect(state => ({auth: state.auth}))(ForumComponent)



/** WEBPACK FOOTER **
 ** ./src/components/forum/ForumComponent.js
 **/